export enum Sport {
  Football = 'Football',
  Hockey = 'Hockey',
  MensHockey = 'Men\'s Ice Hockey',
  WomensHockey = 'Women\'s Ice Hockey',
  Softball = 'Softball',
  MensSoccer = 'Men\'s Soccer',
  WomensSoccer = 'Women\'s Soccer',
  MensLacrosse = 'Men\'s Lacrosse',
  WomensLacrosse = 'Women\'s Lacrosse',
}

export enum League {
  NCAA = 'NCAA',
  AHL = 'AHL',
  NHL = 'NHL',
  EPL = 'EPL',
  EPL2 = 'EPL2',
  EFL = 'EFL',
  EFLC = 'EFLC',
  GermanBundesliga = 'German Bundesliga',
}

export const HockeySports: Array<string> = [Sport.Hockey, Sport.MensHockey, Sport.WomensHockey];
export const SoccerSports: Array<string> = [Sport.MensSoccer, Sport.WomensSoccer];
export const LacrosseSports: Array<string> = [Sport.MensLacrosse, Sport.WomensLacrosse];

export enum FootballQualifiers {
  O = 'O',
  D = 'D',
  K = 'K',
  Continuity = 'Continuity',
  All_30 = 'All 30',
  Program = 'Program',
  TV_Full = 'TV Full',
  TV_1 = 'TV 1',
  TV_2 = 'TV 2',
  TV_3 = 'TV 3',
  TV_4 = 'TV 4',
  TV_5 = 'TV 5',
  Other = 'Other',
}

export enum FootballComplianceBoards {
  ODK = 'ODK',
  TV = 'TV',
}

export enum VideoCodec {
  H264 = 'H264',
  H265 = 'H265',
  AV1 = 'AV1',
  VP9 = 'VP9',
  MPEG4 = 'MPEG4',
  ProRes = 'ProRes',
  Unknown = 'Unknown',
}
